export default "__VITE_ASSET__f3348af8__"